export enum InstrumentTypeEnum {
  PreProgramSurvey = 100,
  PostProgramSurvey = 200,
  PreSessionSurvey = 300,
  PostSessionSurvey = 400,
  Feedback = 500,
}
